<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="card-body" *ngIf="loading" style="text-align: center;">
      <div class="spinner-border mr-50" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <!-- contact us -->
    <section class="faq-contact" *ngIf="!loading">
      <div class="row pt-75">
        <div class="col-sm-4">
          <div class="card text-center faq-contact-card shadow-none py-1">
            <div class="card-body">
              <div class="avatar avatar-tag bg-light-primary mb-2 mx-auto">
                <i data-feather="headphones" class="font-medium-3"></i>
              </div>
              <h4>Open New Request</h4>
              <span class="text-body">We are always happy to help!</span>
            </div>
          </div>
          <div class="card shadow-none py-1">
            <div class="card-body">
              <form
                id="form-modal-todo"
                class="todo-modal needs-validation"
                (ngSubmit)="(todoForm.form.valid)"
                #todoForm="ngForm"
              >                <div class="action-tags">
                  <div class="form-group">
                    <label for="todoTitleAdd" class="form-label d-block">Title</label>
                    <input
                      type="text"
                      id="todoTitleAdd"
                      name="title"
                      class="new-todo-item-title form-control"
                      [class.error]="todoForm.submitted && TDNameRef.invalid"
                      placeholder="Title"
                      [(ngModel)]="todo.title"
                      maxlength="50"
                      #TDNameRef="ngModel"
                      required
                      tabindex="1"
                    />
                    <span *ngIf="todoForm.submitted && TDNameRef.invalid" class="invalid-form">
                      <small class="form-text text-danger" *ngIf="TDNameRef.errors.required">This field is required!</small>
                    </span>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Description</label>
                  <fieldset class="form-label-group mb-0">
                    <textarea
                      #textLength
                      id="todoDescriptionAdd"
                      name="description"
                      class="form-control char-textarea"
                      [class.error]="todoForm.submitted && TDADescriptionRef.invalid"
                      placeholder="Description"
                      [(ngModel)]="todo.description"
                      #TDADescriptionRef="ngModel"
                      [maxlength]="500"
                      rows="3"
                      required
                      tabindex="2"
                    ></textarea>
                  </fieldset>
                  <small class="textarea-counter-value float-right"
                    ><span *ngIf="TDADescriptionRef" class="char-count">{{ textLength.value.length }}</span>
                    <span *ngIf="!TDADescriptionRef" class="char-count">0 </span> / 500
                  </small>
                  <span *ngIf="todoForm.submitted && TDADescriptionRef.invalid" class="invalid-form">
                    <small class="form-text text-danger" *ngIf="TDADescriptionRef.errors.required">This field is required!</small>
                  </span>
                  </div>
                  <div class="form-group">
                    <label for="priority" class="form-label d-block">Priority</label>
                    <select name="priority" class="form-control" id="priority" [(ngModel)]="todo.priority" style="font-size: 14px; height: 40px;" tabindex="3">
                      <option value="1">High</option>
                      <option value="2">Medium</option>
                      <option value="3">Low</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="category" class="form-label d-block">Support Category</label>
                    <select name="category" class="form-control" id="category" [(ngModel)]="todo.category" style="font-size: 14px; height: 40px;" tabindex="4">
                      <option value="feature">Feature</option>
                      <option value="bug">Technical Issues & Bugs</option>
                      <option value="enquiry">Enquiry</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  
                  <label for="imageInput" class="form-label d-block">Upload Image</label>
                  <div class="custom-file">
                    <input
                      type="file" 
                      id="imageInput"           
                      class="custom-file-input"
                      name="image" 
                      accept="image/*"                       
                      #TDAImageRef="ngModel"
                      [(ngModel)]="todo.image" 
                      tabindex="5" 
                      (change)="uploadFile($event)"
                    />
                    <label class="custom-file-label" for="imageInput">{{todo.image.name}}</label>
                  </div>
                </div>
                <div class="form-group my-1">
                  <button
                    type="submit"
                    class="btn btn-primary add-todo-item mr-1"
                    (click)="addTodo(todoForm)"
                    rippleEffect
                    tabindex="6"
                    [disabled]="loadingbtn"
                  >
                  <span *ngIf="loadingbtn" class="spinner-border spinner-border-sm mr-1"></span>
                    Add
                  </button>

                </div>
        
              </form>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="card" style="overflow-x: scroll !important;">
            <div class="card-body">            
              <div class="row">
                <div class="col-12">
                  <ngx-datatable
                    [rows]="rows"
                    [rowHeight]="50"
                    class="bootstrap core-bootstrap"
                    [limit]="20"
                    [columns]="columns"
                    [columnMode]="ColumnMode.force"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [scrollbarH]="true"
                    [sorts]="[{prop: 'created_at', dir: 'desc'}]"
                    style="width: 100%;"
                  >
                  <ngx-datatable-column name="Priority" prop="priority" [width]="10">
                    <ng-template let-priority="value" ngx-datatable-cell-template>
                      <div
                        class="badge badge-pill"
                        [ngClass]="{
                          'badge-light-danger': priority == '1',
                          'badge-light-secondary': priority == '3',
                          'badge-light-warning': priority == '2'
                        }"
                      >
                        {{ priority }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                    <ngx-datatable-column name="Date" prop="created_at" [width]="100">
                      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template >
                          {{ getDate(row.created_at) | date:'dd/MM/yyyy' }}
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Title" prop="title" [width]="200"></ngx-datatable-column>
                    <ngx-datatable-column name="Category" prop="category" [width]="50"></ngx-datatable-column>
                    <ngx-datatable-column name="Status" prop="status" [width]="50">
                      <ng-template let-status="value" ngx-datatable-cell-template>
                        <div
                          class="badge badge-pill"
                          [ngClass]="{
                            'badge-light-secondary': status == 'open',
                            'badge-light-warning': status == 'pending',
                            'badge-light-info': status == 'in progress',
                            'badge-primary': status == 'completed',
                            'badge-warning': status == 'in review',
                            'badge-light-danger': status == 'accepted',
                            'badge-danger': status == 'rejected',
                            'badge-primary': status == 'blocked',
                            'badge-light-success': status == 'closed'
                          }"
                        >
                          {{ status }}
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    <!--/ contact us -->
  </div>
</div>

<!-- Modal -->
<ng-template #modalLG let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Invite a New Member</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus style="height: 400px; overflow-y: scroll;">
    <form action="#" #newInviteForm="ngForm">
      <div class="row">
        <!-- First Name -->
        <div class="form-group col-6">
          <label class="form-label" for="basic-icon-default-firstname">First Name</label>
          <input
            type="text"
            class="form-control dt-first-name"
            id="basic-icon-default-firstname"
            placeholder="John"
            name="user-firstname"
            [(ngModel)]="inviteContent['firstName']"
            [value]=""
            [class.error]="newInviteForm.submitted && FFirstNameRef.invalid"
            #FFirstNameRef="ngModel"
            required
            aria-label="John"
            aria-describedby="basic-icon-default-firstname2"
          />
          <span *ngIf="newInviteForm.submitted && FFirstNameRef.invalid" class="invalid-form">
            <small class="form-text text-danger" *ngIf="FFirstNameRef.errors.required">This field is required!</small>
          </span>
        </div>
        <!-- / First Name -->

        <!-- Last Name -->
        <div class="form-group col-6">
          <label class="form-label" for="basic-icon-default-lastname">Last Name</label>
          <input
            type="text"
            id="basic-icon-default-lastname"
            class="form-control dt-lastname"
            placeholder="Doe"
            aria-label="Doe"
            aria-describedby="basic-icon-default-lastname2"
            name="user-lastname"
            [(ngModel)]="inviteContent['lastName']"
            [class.error]="newInviteForm.submitted && FLastNameRef.invalid"
            #FLastNameRef="ngModel"
            required
          />
          <span *ngIf="newInviteForm.submitted && FLastNameRef.invalid" class="invalid-form">
            <small class="form-text text-danger" *ngIf="FLastNameRef.errors.required">This field is required!</small>
          </span>
        </div>
        <!-- / Last Name -->
        
        <!-- Email -->
        <div class="form-group col-6">
          <label class="form-label" for="basic-icon-default-email">Email</label>
          <input
            type="text"
            id="basic-icon-default-email"
            class="form-control dt-email"
            placeholder="john.doe@example.com"
            aria-label="john.doe@example.com"
            aria-describedby="basic-icon-default-email2"
            name="user-email"
            [(ngModel)]="inviteContent['contact']"
            [class.error]="newInviteForm.submitted && FEmailRef.invalid"
            #FEmailRef="ngModel"
            required
          />
          <span *ngIf="newInviteForm.submitted && FEmailRef.invalid" class="invalid-form">
            <small class="form-text text-danger" *ngIf="FEmailRef.errors.required">This field is required!</small>
          </span>
          <small class="form-text text-muted"> You can use a valid email. </small>
        </div>
        <!-- / Email -->

        <!-- Phone -->
        <div class="form-group col-6">
          <label class="form-label" for="basic-icon-default-email">Phone</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">+61</span>
            </div>
            <input 
            type="text" 
            id="basic-icon-default-phone"
            class="form-control" 
            placeholder="0000 000 000"
            mask="9000 000 000" 
            aria-describedby="basic-icon-default-phone2"
            name="user-phone"
            [(ngModel)]="inviteContent['phone']"
            [class.error]="newInviteForm.submitted && FPhoneRef.invalid"
            #FPhoneRef="ngModel"
            required
          />
          </div>
          <span *ngIf="newInviteForm.submitted && FPhoneRef.invalid" class="invalid-form">
            <small class="form-text text-danger" *ngIf="FPhoneRef.errors.required">This field is required!</small>
          </span>
          <small class="form-text text-muted"> You can only use numbers </small>                    
        </div>    
        <!-- / Phone -->

      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" rippleEffect>
      Send Invite
    </button>
  </div>
</ng-template>
<!-- / Modal -->